import type { CypherDataType } from '@nx/neo4j-sdk';
import { compareCypherValues } from '@nx/neo4j-sdk';
import type { SortingFn } from '@tanstack/react-table';
import type { Record as Neo4jRecord } from 'neo4j-driver';

export const convertKeyToString = (key: PropertyKey) => {
  let keyString = 'unknown';
  if (typeof key === 'string') {
    keyString = key;
  } else if (typeof key === 'number') {
    keyString = String(key);
  } else if (typeof key === 'symbol') {
    const keyStringOrUndefined = key.toString();
    if (keyStringOrUndefined) {
      keyString = `symbol_${keyStringOrUndefined};`;
    }
  }
  return keyString;
};

export const getHeaderKeys = (records: Neo4jRecord[]) => {
  if (records.length === 0) {
    return [];
  }
  const [firstRecord] = records;
  if (firstRecord === undefined) {
    return [];
  }
  return firstRecord.keys.map((key) => convertKeyToString(key));
};

export const sortCypherValues: SortingFn<Record<string | number | symbol, CypherDataType>> = (rowA, rowB, columnId) => {
  const valueA = rowA.getValue<CypherDataType | undefined>(columnId);
  const valueB = rowB.getValue<CypherDataType | undefined>(columnId);
  return compareCypherValues(valueA, valueB);
};
